<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'孵化器管理'},{name:'孵化器列表',goback:true},{name:'孵化器明细'}]" :title="'孵化器明细'" ref="breadcrumb"/>
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="孵化器详情" name="1"></el-tab-pane>
              <el-tab-pane label="场地" name="2"></el-tab-pane>
              <el-tab-pane label="入驻申请" name="3"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve border" v-show="tab!=='1'" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">场地类型：</span>
                        <el-select v-model="siteInfo.siteType" placeholder="请选择" size="small" @change="getList()" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child" v-show="tab==='3'">
                        <span class="name">受理状态</span>
                        <el-select  v-model="applicationInfo.rate" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusLists"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child" v-show="tab==='3'">
                        <span class="name">发布日期</span>
                        <el-date-picker
                            size="small"
                            v-model="sendInfo.time"
                            format="yyyy-MM-dd"
                        	value-format="yyyy-MM-dd HH:mm:ss"
                        	type="datetimerange" 
                        	:default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select" v-show="tab==='3'">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfo.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfo.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn" v-show="tab==='3'">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn" v-show="tab==='3'">重置</el-button>
                </div>
            </div>
            <!-- 主体 -->
            <!-- 孵化器详情 -->
            <div class="box detailBas" v-show="tab==='1'">
                <el-card class="basic box_card" header="" shadow="never">
                    <div class="basisTitle">基本信息</div>
                    <el-row>
                      <el-col :span="8">
                        <div class="child">
                            <div class="name">孵化器名称：</div>
                            <div class="content">{{dataInfo.incubatorName||'--'}}</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                          <div class="child">
                              <div class="name">场地租金：</div>
                              <div class="content">{{dataInfo.rent||'--'}}</div>
                          </div>
                      </el-col>
                      <el-col :span="8">
                          <div class="child">
                              <div class="name">孵化器总面积：</div>
                              <div class="content">{{dataInfo.area||'--'}}</div>
                          </div>
                      </el-col>
                      <el-col :span="8">
                          <div class="child">
                            <div class="name">所在地区：</div>
                            <div class="content">{{dataInfo.provinceValue+dataInfo.cityValue+dataInfo.areaValue}}</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                          <div class="child">
                              <div class="name">联系手机号：</div>
                              <div class="content">{{dataInfo.contactPhone||'--'}}</div>
                          </div>
                      </el-col>
                      <el-col :span="8">
                          <div class="child">
                              <div class="name">建成时间：</div>
                              <div class="content">{{dataInfo.builtTime||'--'}}</div>
                          </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      
                      <el-col :span="8">
                        <div class="child">
                            <div class="name">详细地址：</div>
                            <div class="content">
                                {{dataInfo.address}}
                              <div id="mapShow" class="map"></div>
                            </div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      
                      <el-col :span="24">
                        <div class="child">
                            <div class="name">简介：</div>
                            <div class="content">
                            {{dataInfo.remark||'--'}}
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                          <div class="child">
                            <div class="name">孵化器照片：</div>
                            <div class="content" v-show="dataInfo">
                                <div class="content-img" v-for="(img,index) in dataInfo.fileList" :key="index">
                              <div v-if="img.isCover==1">封面</div>
                              <img style="width: 100%;height: 100%;" :src="dataInfo.frontPath+img.filePath" class="images">
                            </div>
                              
                            </div>
                        </div>
                      </el-col>
                      </el-row>
                    <el-row>
                      <el-col :span="24">
                          <div class="child">
                              <div class="name">招商产业：</div>
                            <div class="content">
                              {{dataInfo.industry||'--'}}
                            </div>
                          </div>
                      </el-col>
                      </el-row>
                    <el-row>
                      <el-col :span="24">
                          <div class="child">
                              <div class="name">配套设施：</div>
                            <div class="content">
                              {{dataInfo.facilities||'--'}}
                            </div>
                          </div>
                      </el-col>
                      </el-row>
                    <el-row>
                      <el-col :span="24">
                          <div class="child">
                              <div class="name">地理环境：</div>
                            <div class="content">
                              {{dataInfo.environment||'--'}}
                            </div>
                          </div>
                      </el-col>
                      </el-row>
                    <el-row>
                      <el-col :span="24">
                          <div class="child">
                              <div class="name">交通路线：</div>
                            <div class="content">
                              {{dataInfo.trafficRoutes||'--'}}
                            </div>
                          </div>
                      </el-col>
                      </el-row>
                    <el-row>
                      <el-col :span="24">
                          <div class="child">
                              <div class="name">其它服务：</div>
                            <div class="content">
                              {{dataInfo.otherServices||'--'}}
                            </div>
                          </div>
                      </el-col>
                    </el-row>
                </el-card>
                <el-card class="basic box_card mt20" header="" shadow="never">
                    <div class="basisTitle">其它信息：</div>
                    <el-row>
                      <el-col :span="8">
                          <div class="child">
                              <div class="name">发布账号：</div>
                              <div class="content">
                                {{dataInfo.createUserName||'--'}}
                              </div>
                          </div>
                      </el-col>
                      <el-col :span="8">
                          <div class="child">
                            <div class="name">发布时间：</div>
                            <div class="content">
                              {{dataInfo.createTime||'--'}}
                            </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                          <div class="child">
                              <div class="name">更新账号：</div>
                              <div class="content">
                                {{dataInfo.modifyUserName||'--'}}
                              </div>
                          </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="child">
                          <div class="name">更新时间：</div>
                          <div class="content">
                            {{dataInfo.updateTime||'--'}}
                          </div>
                      </div>
                      </el-col>
                    </el-row>
                </el-card>
            </div>
            <!-- 场地 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
				        :default-sort="{prop: 'date'}"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                style="width: 100%">
                <el-table-column
                    prop="siteTypeValue"
                    show-overflow-tooltip
                    
                    label="场地类型">
                </el-table-column>
                <el-table-column
                    prop="room"
                    show-overflow-tooltip
                    
                    label="房型">
                </el-table-column>
                <el-table-column
                    prop="unitPrice"
                    show-overflow-tooltip
                    
                    label="单价">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="面积（m²）">
					<template slot-scope="scope">
					    <div>{{scope.row.minArea+'-'+scope.row.maxArea}}</div>
					</template>
                </el-table-column>
                <el-table-column
                    prop="maxAccommodateNum"
                    show-overflow-tooltip
                    
                    width="200"
                    label="最大容纳人数">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="创建时间">
                </el-table-column>
            </el-table>
            <!-- 客户申请表格 -->
            <el-table
                v-show="tab==='3'"
                :data="tableData"
				:default-sort="{prop: 'date'}"
        @sort-change="sortChange"
                ref="multipleTable"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="rateValue"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="受理状态">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" v-show="tab!=='1'" ref="pagination">
            	<Paging
            	:PageData="PageData"
            	@nextpage="nextpage"
            	@previouspage="previouspage"
            	@handleSizeChange="handleSizeChange"
            	@handleCurrentChange="handleCurrentChange"
            	></Paging>
            </div>
            <!-- 弹出成模块 -->
            <!-- 明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                custom-class="super_dialog"
                width="60%">
                    <div class="basic boxChild">
                        <div class="tit">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{dataInfos.applicant||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{dataInfos.contactPhone||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{dataInfos.applyCompany||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content"> {{dataInfos.applyRemark||'--'}}</div>
                        </div>
                        <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content" v-if="dataInfos&&dataInfos.fileList.length>0">
                                <li v-for="(i,index) in dataInfos.fileList" :key="index"><span>{{i.fileName}}</span>
                        		<i class="el-icon-download" @click="downLoad(i)"></i></li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{dataInfos.createTime||'--'}}</div>
                        </div>
                        <div class="tit mts">受理信息</div>
                        <div class="child">
                            <div class="name">受理状态：</div>
                            <div class="content">{{dataInfos.rateValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{dataInfos.dealWithRemark}}</div>
                        </div>
                        <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{dataInfos.updateTime}}</div>
                        </div>
                    </div>
            </el-dialog>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {getDict} from "@/axios";
import Paging from '../../components/Paging';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb,
        Paging
    },
    data(){
        return{
            bHeight: void 0,
            id:'',//详情id
            tab:'1',//选项卡
			statusList:[],//场地类型
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '申请人姓名'
            }, {
                value: '4',
                label: '联系手机号'
            }],//检索下拉
            sendInfo:{
                name1:'',//场地类型
                time:'',//提交日期
                drop:'',//检索选择值
                dropValue:'',//检索输入值
            },//检索条件
            tableData:[],//表格数据
			// 场地信息
			siteInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				incubatorId:this.$route.query.id,//孵化器id
				siteType:null,//场地状态
			},
			// 入驻申请
			applicationInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				incubatorId:'',//孵化器id
				siteType:null,//场地状态
				id:null,//申请id
				userName:null,//账号
				applicant:null,//申请人姓名
				contactPhone:null,//联系手机
				startDate:null,
				endDate:null,
                loanId:this.$route.query.id,
                rate:null,
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            center:{},//地图中心点
            maker:{},//标记点
            zoom:15,//缩放等级
			dataInfo:'',//孵化器详情
            dataInfos:'',//入驻详情
            statusLists:[],
        }
    },
    methods:{
      onReset(){
        const param = {
          currentPage:1,//当前页
				pageSize:10,//页条数
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				incubatorId:this.$route.query.id,//孵化器id
				siteType:this.siteInfo.siteType,//场地状态
        }
        this.applicationInfo.rate = void 0
        this.siteInfo = Object.assign(this.siteInfo,param)
        this.getList()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		ready() {
			let map = new BMap.Map("mapShow");    
			let point = new BMap.Point(this.center.lng, this.center.lat);    
			map.centerAndZoom(point, 16);    
			map.enableScrollWheelZoom(true);
			map.enableDoubleClickZoom(true);
			let marker = new BMap.Marker(point);        // 创建标注    
			map.addOverlay(marker);                     // 将标注添加到地图中 
		},
		getDetail(){
			this.$axiosc.get('backstage/incubator/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
					this.maker={lng: r.data.longitude, lat: r.data.latitude};
					this.center={lng: r.data.longitude, lat: r.data.latitude};
					setTimeout(()=>{
						this.ready()
					},500)
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
		// 获取场地信息
		getList(){
			let tab=this.tab;
			if(tab==='2'){
				// 场地
				this.$axiosc.get('backstage/incubator/site/management',{params:this.siteInfo}).then(res=>{
				    if(res.code==200){
				        this.tableData=res.data.content;
				        this.PageData.currentPage =res.data.currentPage; //当前页
				        this.PageData.total =res.data.totalElements;
				    }else{
				        this.$alert(res.msg)
				    }
				})
			}else if(tab==='3'){
				// 入驻申请
				this.$axiosc.get('/backstage/incubator/apply/loanId/list',{params:this.applicationInfo}).then(res=>{
				    if(res.code==200){
				        this.tableData=res.data.content;
				        this.PageData.currentPage =res.data.currentPage; //当前页
				        this.PageData.total =res.data.totalElements;
				    }else{
				        this.$alert(res.msg)
				    }
				})
			}
		},
        // 切换选项啦
        changeTab:function(tab){
            this.tab=tab.name;
			this.getList()
        },
        //检索事件
        retrieval:function(){
			let lookData=this.sendInfo;
			if(lookData.time&&lookData.time.length>0){
				this.applicationInfo.startDate=lookData.time[0];
				this.applicationInfo.endDate=lookData.time[1];
			}else {
                this.applicationInfo.startDate=null;
                this.applicationInfo.endDate=null;
            }
			// 检索值
			let lookdell=lookData.drop;
			this.applicationInfo.id=null;
			this.applicationInfo.userName=null;
			this.applicationInfo.applicant=null;
			this.applicationInfo.contactPhone=null;
			if(lookdell==1){
				this.applicationInfo.id=lookData.dropValue;
			}else if(lookdell==2){
				this.applicationInfo.userName=lookData.dropValue;
			}else if(lookdell==3){
				this.applicationInfo.applicant=lookData.dropValue;
			}else if(lookdell==4){
				this.applicationInfo.contactPhone=lookData.dropValue;
			}
			this.getList()
		},
        //地图创建
        handler:function({BMap, map}){
            this.center=this.center;
            this.maker=this.maker;
            this.zoom=15;
        },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            if(this.tab === '2'){
            this.siteInfo.property=prop;
            this.siteInfo.direction=order;
            }else{
               this.applicationInfo.property=prop;
              this.applicationInfo.direction=order;
            }
            this.getList();
        },
        //查看
        check:function(row){
			this.$axiosc.get('backstage/incubator/apply/already/details/'+row.id).then((r)=>{
			    if(r.code==200){
					this.dataInfos=r.data;
					this.dialogInfo=true;
			    }else{
			        this.$alert(r.msg);
			    }
			})
        },
        //下载附件
        downLoad:function({fileName,filePath}){
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
       },
        //分页功能模块
        // 下一頁
        nextpage(val) {
		  if(this.tab==='2'){
			  this.siteInfo.currentPage = val;
		  }else if(this.tab==='3'){
			  this.applicationInfo.currentPage=val
		  }
          this.getList();
        },
        // 上一頁
        previouspage(val) {
		  if(this.tab==='2'){
			  this.siteInfo.currentPage=val;
		  }else if(this.tab==='3'){
			  this.applicationInfo.currentPage=val
		  }
          this.getList();
        },
        handleSizeChange(val) {
		  if(this.tab==='2'){
			  this.siteInfo.pageSize = val;
		  }else if(this.tab==='3'){
			  this.applicationInfo.pageSize=val
		  }
          this.getList()
        },
        handleCurrentChange(val) {
		  if(this.tab==='2'){
			  this.siteInfo.currentPage = val;
		  }else if(this.tab==='3'){
			  this.applicationInfo.currentPage=val
		  }
          this.getList()
        },
    },
    created(){
		// SITE_TYPE
        if(this.$route.query.id){
            this.id=this.$route.query.id;
        }
		getDict('SITE_TYPE').then(data=>{
		    this.statusList = data.SITE_TYPE;
        })
        this.$axiosz.get('backstage/sysDict/ACCEPTANCE_STATUS').then((r)=>{ //受理状态
            if(r.code==200){
                this.statusLists=r.data;
            }
        })
		this.getDetail()
    },
    mounted(){
      const that = this
      let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0)
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0)
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
	watch:{
		'sendInfo.drop': {
        handler(val, oldVal) {
         this.sendInfo.dropValue=''
        },
        deep: true
      }
	}
}
</script>

<style lang="scss" scoped>
.warp{
    height:calc(100% - 20px);
    padding:10px 20px;
    .detailBas{
        margin-top: 20px;
        overflow-x:hidden;
        overflow-y: auto;
        height:calc(100% - 110px);
    }
}
.basic{
	.content{
		p{
			line-height: 20px;
		}
	}
    .tit{
        font-weight: 600;
        color: #000;
    }
    .mts{
        margin-top: 20px;
    }
}
.content-img{
		position: relative;
		width: 117px;
		height: 117px;
		float: left;
		margin-right: 20px;
		margin-bottom: 20px;
		div{
			position: absolute;
			top: 0;
			right: 0;
			z-index: 100;
			color: #fff;
			background: #2D2D2D;
			font-size: 14px;
			padding: 3px;
		}
	}

  .box{
    margin-top: 10px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:0 !important;
        }
      }
    }
    .tableChild{
      margin-top:8px !important;
    }
    .child,.attachment{
      margin-top:8px;
    }
}
.boxChild{
  .child,.basisTitle,.tit,.attachment{
      margin-bottom:10px;
    }
    .name{
      width:85px;
      text-align: right;
    }
}
</style>